import JwtBaseClient from './JwtBaseClient';

class TermsOfServiceClient {
  static tosAcceptanceCacheTime;

  static tosAcceptanceCacheValue;

  constructor(user) {
    const headers = {
      'Content-Type': 'application/json',
    };
    this.jwtBaseClient = new JwtBaseClient(import.meta.env.VITE_EULA_TOS_SERVICE_URI, headers);
    this.user = user;
    this.uri = 'api/eulaacceptance';
  }

  static get isTosCacheExpired() {
    if (!this.tosAcceptanceCacheTime) {
      return true;
    }

    return Date.now() - this.tosAcceptanceCacheTime > 2000;
  }

  blanketApproveTermsOfService({ eulaId, acceptedDate }) {
    const data = {
      eulaId,
      acceptedDate,
    };
    return this.jwtBaseClient.post(`${this.uri}/allusersorganizations`, data)
      .then((response) => response.data?.data);
  }

  checkNeedTosAcceptance() {
    // Cache the result of this call for 2 seconds, as it is used in multiple places
    // on the app, and we want to avoid multiple calls in a short time frame.
    // The cache will be updated when the call resolves, so any calls while this is
    // pending will not trigger additional calls.
    // Cache ToS call on class in case multiple files make the same call
    if (this.constructor.isTosCacheExpired) {
      this.constructor.tosAcceptanceCacheTime = Date.now();
      const result = this.jwtBaseClient.get(`${this.uri}/acceptancerequired`)
        .then((response) => response.data?.data);
      this.constructor.tosAcceptanceCacheValue = result;
    }
    return this.constructor.tosAcceptanceCacheValue;
  }
}
export default TermsOfServiceClient;
